<template>
  <tr :key="value.id">
    <td v-for="header in headers" :key="header.text">
      <span v-if="header.value === 'name'">
        <v-icon :color="value.color">
          {{ value.icon }}
        </v-icon>

        {{ value.name }}
      </span>

      <v-chip
        v-else-if="header.value === 'status'"
        :color="getStatus(value).color"
        dark
      >
        {{ getStatus(value).text }}
      </v-chip>

      <v-chip v-else-if="header.value === 'duration'"> </v-chip>

      <span v-else-if="header.value === 'created_at'">
        {{ formatDates(value.created_at) }}
      </span>
      <span v-else>
        {{ value[header.value] }}
      </span>
    </td>
  </tr>
</template>


<script>
import moment from "moment";

export default {
  props: {
    headers: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {},
  data() {
    return {
      fullScreenPreview: false,
    };
  },
  methods: {
    formatDates(date) {
      return moment(date).format("MMMM Do");
    },
    getStatus(item) {
      return item && item.status && item.status.code
        ? {
            text: item.status.code,
            color: item.status.color
          }
        : {
            text: "unknown",
            color: "grey",
          };
    },
  },
};
</script>